import {	Component,	OnInit} from '@angular/core';
import {	AppComponent} from './../app.component';

@Component({
	selector: 'app-tab3',
	templateUrl: 'tab3.page.html',
	styleUrls: ['tab3.page.scss']
})
export class Tab3Page implements OnInit {
	activated: any;
	constructor() {
		this.activated = "sym";
	}


	ngOnInit() {

    // collapse card script
		var acc = document.getElementsByClassName("accordion");
		var i;
		for (i = 0; i < acc.length; i++) {
			acc[i].addEventListener("click", function () {
				/* Toggle between adding and removing the "active" class,
				to highlight the button that controls the panel */
				this.classList.toggle("active");

				/* Toggle between hiding and showing the active panel */
				var panel = this.nextElementSibling;
				if (panel.style.display === "block") {
					panel.style.display = "none";
				} else {
					panel.style.display = "block";
				}
			});
		}
	}


	public AppRef = AppComponent;

	setLang() {
		if (AppComponent.languageToggle) {
			AppComponent.currentLang = 'english';
		} else {
			AppComponent.currentLang = 'hindi';
		}
	}
	symChange() {
		let sym = document.getElementById('symptoms');
		let pre = document.getElementById('precaution');
		sym.style.display = "block";
		pre.style.display = "none";
	}
	preChange() {
		let sym = document.getElementById('symptoms');
		let pre = document.getElementById('precaution');
		let info = document.getElementById('info');
		sym.style.display = "none";
		pre.style.display = "block";
		info.style.display = "block";
	}
}